import { useOptimizely } from '@libs/common-next';
import { docs } from '../config';
import css from './actions.module.scss';

export function Actions() {
    const { instance } = useOptimizely();

    return (
        <>
            {docs.actions(instance?.getProjectConfig()).map(action => (
                <div key={action.title} className={css.action}>
                    <div>
                        <p>{action.title}</p>
                        <span>{action.subtitle}</span>
                    </div>
                    {action.action.url ? (
                        <a
                            target="_blank"
                            href={action.action.url}
                            className={css.button}
                        >
                            {action.action.text}
                        </a>
                    ) : (
                        <span className={css.env}>{action.action.text}</span>
                    )}

                    <span className={css.description}>
                        {action.description}
                    </span>
                </div>
            ))}
        </>
    );
}
